<div
    #container
    class="signature-pad-container"
    [class.signature-pad-hidden]="readonly"
    [class.signature-pad-disabled]="disabled"
    [style.backgroundColor]="backgroundColor"
    [style.height.px]="height">
    <canvas #signatureCanvas class="signature-pad-canvas"></canvas>
</div>

<div
    *ngIf="readonly"
    class="signature-pad-preview-container"
    [style.backgroundColor]="backgroundColor"
    [style.height.px]="height">
    <img
        *ngIf="previewValue"
        [src]="previewValue"
        class="signature-pad-preview-image" />
</div>